export const pastExportsKeys = {
  all: ['dataHub', 'pastExports'] as const,
  lists: () => [...pastExportsKeys.all, 'list'] as const,
  details: () => [...pastExportsKeys.all, 'detail'] as const,
  detail: (exportId: string) => [...pastExportsKeys.details(), exportId] as const
};
